import React from 'react';
import { Logo } from './Logo';
import { Globe, CalendarCheck } from 'lucide-react';
import { navigate, BOOKING_URL } from '../lib/navigation';
export function Footer() {
  const links = [{
    name: 'About',
    href: '#/about'
  }, {
    name: 'Services',
    href: '#/services'
  }, {
    name: 'Newsletter',
    href: '#/newsletter'
  }, {
    name: 'Get Started',
    href: '#/get-started'
  }];
  const legalLinks = [{
    name: 'Privacy Policy',
    href: '#/privacy-policy'
  }, {
    name: 'Terms of Service',
    href: '#/terms-of-service'
  }, {
    name: 'Accessibility',
    href: '#/accessibility'
  }, {
    name: 'Professional Registration',
    href: '#/professional-registration'
  }];
  return <footer className="bg-teal text-white py-16" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-41">
          {/* Column 1: Brand Info */}
          <div className="space-y-6" data-id="element-42">
            <div className="bg-white/10 p-4 rounded-lg inline-block w-fit" data-id="element-43">
              <Logo className="h-10 w-auto [&_text]:fill-white [&_path]:stroke-white" data-id="element-44" />
            </div>
            <div className="space-y-2 text-white/80" data-id="element-45">
              <p className="font-medium" data-id="element-46">
                Jessica Ruppert, MA, RP (Qualifying)
              </p>
              <p data-id="element-47">Online therapy across Ontario</p>
              <a href="mailto:jess@arrivetherapy.ca" className="text-terracotta hover:text-white transition-colors" data-id="element-48">
                jess@arrivetherapy.ca
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-49">
            <h4 className="text-lg font-semibold mb-6 text-terracotta" data-id="element-50">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-51">
              {links.map(link => <li key={link.name} data-id="element-52">
                  <a href={link.href} onClick={e => {
                e.preventDefault();
                navigate(link.href);
              }} className="text-white/80 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-53">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div data-id="element-54">
            <h4 className="text-lg font-semibold mb-6 text-terracotta" data-id="element-55">
              Legal
            </h4>
            <ul className="space-y-4" data-id="element-56">
              {legalLinks.map(link => <li key={link.name} data-id="element-57">
                  <a href={link.href} onClick={e => {
                e.preventDefault();
                navigate(link.href);
              }} className="text-white/80 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-58">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div data-id="element-59">
            <h4 className="text-lg font-semibold mb-6 text-terracotta" data-id="element-60">
              Connect
            </h4>
            <ul className="space-y-4" data-id="element-61">
              <li data-id="element-62">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex items-center text-white/80 hover:text-white transition-colors group" data-id="element-63">
                  <CalendarCheck className="w-5 h-5 mr-3 group-hover:text-terracotta transition-colors" data-id="element-64" />
                  Book Now
                </a>
              </li>
              <li data-id="element-65">
                <a href="https://www.psychologytoday.com/profile/1249899" target="_blank" rel="noopener noreferrer" className="flex items-center text-white/80 hover:text-white transition-colors group" data-id="element-66">
                  <Globe className="w-5 h-5 mr-3 group-hover:text-terracotta transition-colors" data-id="element-67" />
                  Psychology Today
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-sm text-white/60" data-id="element-68">
          <p data-id="element-69">© 2026 Arrive Psychotherapy & Wellness. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}